import React from 'react'
import SimpleBanner from '../../components/common/SimpleBanner'
import CareerPage from '../../components/User/Career/Careerpage'

const Career = () => {
  return (
    <div>
        <SimpleBanner title='Careers' />
        <CareerPage/>
    </div>
  )
}

export default Career